module.exports = __webpack_public_path__ + "static/media/fly0045.145fe5a2.webp";